import { createSelector } from 'reselect'
import { getEntityArray, getReportEventId, type IState } from '../reducers'
import { processLocation } from '../../utils/location'
import { Cale_getEventCompletion } from '../../../zap/Cale/Cale.getEventCompletion'
import { Loca_prepareFocusList } from '../../../zap/Loca/Loca.prepareFocusList'
import type {
    Type_ILocation,
    Type_ILocationFocusList,
    Type_IProcessedCalendarEvent,
    Type_IProcessedLocation,
    Type_IReport,
} from '../../../zap/Type/Type.hive'

interface ISelectors {
    getProcessedLocations?: (state: IState) => Type_IProcessedLocation[]
    getProcessedCalendarEvents?: (state: IState) => Type_IProcessedCalendarEvent[]
    getProcessedFocusLists?: (state: IState) => Array<Type_ILocationFocusList & { locations: any[] }>
}

const selectors: ISelectors = {}

// Delay the creation of selectors until after load
// to avoid circular dependencies
export function selectorsInitialize() {
    selectors.getProcessedLocations = createSelector(
        (state: IState) => state.common.lat,
        (state: IState) => state.common.lon,
        (state: IState) => getEntityArray(state, 'locations'),
        (lat: number, lon: number, locations: Type_ILocation[]) => locations.map(processLocation(lat, lon))
    )

    // adds the hasLocalReport property
    selectors.getProcessedCalendarEvents = createSelector(
        (state: IState) => getEntityArray(state, 'calendarEvents'),
        (state: IState) => getEntityArray(state, 'reports'),
        getReportEventId,
        Cale_getEventCompletion
    )

    // adds any local reports to the reports array on the focus list locations
    selectors.getProcessedFocusLists = createSelector(
        (state: IState) => getEntityArray(state, 'focusLists'),
        (state: IState) => getEntityArray(state, 'reports'),
        (focusLists: Type_ILocationFocusList[], reports: Type_IReport[]) =>
            focusLists.map((fl) => Loca_prepareFocusList(fl, reports))
    )
}

export default selectors
